export const people = [
  {
    id: 0,
    name: "Creola Katherine Johnson",
    profession: "mathematic",
    accomplishment: "spaceflight calculations",
    imageId: "MK3eW3A",
  },
  {
    id: 1,
    name: "Mario José Molina-Pasquel Henriquez",
    profession: "chemist",
    accomplishment: "discovery of Arctic ozone hole",
    imageId: "mynHUSa",
  },
  {
    id: 2,
    name: "Mohammd Abdus Salam",
    profession: "physicist",
    accomplishment: "electromagnetism theory",
    imageId: "be7W1ji",
  },
  {
    id: 3,
    name: "Percy Lavon Julian",
    profession: "chemist",
    accomplishment: "pioneering cortisone drugs, steroids",
    imageId: "IOjWm71",
  },
  {
    id: 4,
    name: "Subrahmanyan Chandrasekhar",
    profession: "astrophysics",
    accomplishment: "write dwarf star mass calculations",
    imageId: "lrW8x8l",
  }
];
